module.exports = __webpack_public_path__ + "static/media/contract.56187738.svg";